export { default } from './ParticipantSlide';
